import { Controller } from "@hotwired/stimulus"

// Prevents service-line edits while an explicit reprice is in flight. The
// successful Turbo response replaces only these rows to return persisted ids.
export default class extends Controller {
  static targets = ["fieldset"]

  lock() {
    this.fieldsetTarget.disabled = true
  }

  unlock() {
    this.fieldsetTarget.disabled = false
  }
}
